import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
// import AppBar from '@mui/material/AppBar';
import MuiAppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
// import Drawer from '@mui/material/Drawer';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useTheme, styled} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {Link, useHistory, useLocation} from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SecurityIcon from '@mui/icons-material/Security';
import InfoIcon from '@mui/icons-material/Info';
import ReportIcon from '@mui/icons-material/Report';
import {
    faBaby,
    faBuilding,
    faCamera,
    faCameraRetro,
    faChartBar,
    faCity,
    faCloudUploadAlt,
    faDigitalTachograph,
    faExclamationCircle,
    faFileImport,
    faFileInvoice,
    faFilm,
    faFolderOpen, faHandsHelping, faInfoCircle,
    faNewspaper,
    faObjectGroup,
    faProjectDiagram,
    faSearch,
    faSpaceShuttle,
    faTable,
    faTasks,
    faTv,
    faUsers,
    faVideo
} from "@fortawesome/free-solid-svg-icons";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import PushPinIcon from '@mui/icons-material/PushPin';
import Button from "@mui/material/Button";
import logBall from "../../img/Kugelweb.svg";
import {
    axiosGraphQLQuery,
    getPeerconnections,
    getSession,
    logout,
    logoutApp,
    sessionValid,
    setPeerConnection
} from "../Auth/AuthHandler";
import {
    AccountCircle,
    Add,
    CameraIndoor,
    Drafts,
    DragHandle,
    HelpOutline,
    Inbox,
    LocalLibrary,
    Notifications,
    NotificationsActive,
    NotificationsOff,
    Shield,
    TabletAndroid, VideoCameraBack,
    Warning
} from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from "@mui/icons-material/Settings";
import GSButton from "../GSHelperComponents/GSButton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import MuiDrawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {bindMenu, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import PanoramaIcon from '@mui/icons-material/Panorama';
import {blue} from "@mui/material/colors";
import {peerconnectionsStreams} from '../Auth/AuthHandler.js'
import PopupState from "material-ui-popup-state";
import SendIcon from '@mui/icons-material/Send';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import MicIcon from '@mui/icons-material/Mic';
import BadgeIcon from '@mui/icons-material/Badge';
import Crop32Icon from '@mui/icons-material/Crop32';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import GlassSphereContext from "../GlassSphereContext/GlassSphereContext";
import axios from "axios";
import {APIURL} from "../../Views/Routes";
import Grid from "@mui/material/Grid";
import DialogContentText from "@mui/material/DialogContentText";
import FormControl from "@mui/material/FormControl";
import {deviceDetect, isMobile} from 'react-device-detect'
import NotificationDialog, {getPushToken, getWebpush} from "../dialogs/notification/NotificationDialog";
import {v4 as uuidv4} from "uuid";
import ConfirmDialog from "../dialogs/ConfirmDialog";
import useConfirm from "../dialogs/useConfirm";
import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Popover,
    useMediaQuery
} from "@mui/material";
import {Document, Page, pdfjs} from 'react-pdf';
import PdfViewerPanel from './PDFViewPanel';
import ActivityLogPopover from '../ActivityLog/ActivityLogPopover';


const PREFIX = 'ResponsiveDrawer';


const classes = {
    root: `${PREFIX}-root`,
    drawer: `${PREFIX}-drawer`,
    appBar: `${PREFIX}-appBar`,
    menuButton: `${PREFIX}-menuButton`,
    toolbar: `${PREFIX}-toolbar`,
    drawerPaper: `${PREFIX}-drawerPaper`,
    content: `${PREFIX}-content`,
    closeMenuButton: `${PREFIX}-closeMenuButton`
};

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth, transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.enteringScreen,
    }), overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
    }), overflowX: 'hidden', width: `calc(${theme.spacing(7)} + 1px)`, [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(({theme, open}) => ({
    width: drawerWidth, flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box', ...(open && {
        ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme),
    }), ...(!open && {
        ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme),
    }),
}),);

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1), // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1, transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
    }), ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

function ResponsiveDrawer(props) {

    const {content} = props
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [path, setPath] = useState("");
    const [drawerWidth, setDrawerWith] = useState(50)
    const [anchorEl, setAnchorEl] = useState(null);
    const [account, setAccount] = useState(false);
    const [open, setOpen] = useState(false);
    const [expertModus, setExpertModus] = useState(false)
    const [userLevel, setUserlevel] = useState(getSession()?.levels)
    const [userlevelDepartment, setUserlevelDepartment] = useState("")
    const [departmentId, setDepartmentId] = useState(null)
    const [usermenu, setUserMenu] = useState([])
    const {broadcast, loggedIn} = useContext(GlassSphereContext);
    const [localbroadcast, setLocalBroadcast] = broadcast
    const [localloggedIn, setLocalLoggedIn] = loggedIn
    const [notiDialogOpen, setNotiDialogOpen] = useState(false)
    const [notiEnabled, setNotiEnabled] = useState(false)
    const {confirm} = useConfirm()
    const [docsWidth, setDocsWidth] = React.useState(400);
    const isflutter = typeof window.flutter_inappwebview !== 'undefined'
    // const isflutter = true
    const [numPages, setNumPages] = useState(null);
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

    const [docsOpen, setDocsOpen] = useState(false);
    const [anchorElsto, setAnchorElsto] = useState(null);

    let location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (userLevel) setUserMenu(getMenuForUser())
    }, [userLevel])

    useEffect(() => {
        setPath(location.pathname);
    }, [location, setPath]);

    useEffect(() => {
        setPath(location.pathname);
    }, [location, setPath]);

    useEffect(() => {
        // eslint-disable-next-line no-undef

        if (getSession()) {

            var stmt = `{
            gmdepartments(where: [
                {
                    connective: BLANK,
                    column: gmdepartments_gmdmembers,
                    operator: LIKE,
                    value: "%${getSession().userID + ""}%"
                },
                {
                    connective: OR,
                    column: gmdepartments_gmdleaders,
                    operator: LIKE,
                    value: "%${getSession().userID + ""}%"
                }
            ]){
                gmdmembers
                gmdleaders
                gmdid
                gmdname
                gmdtemplateid
        }}`

            axiosGraphQLQuery(stmt, null, false)
                .then(x => {
                    if (x.data.data.gmdepartments) {
                        var loadeddepartmentslist = x.data.data.gmdepartments.map(x => {
                            return {
                                id: x.gmdid,
                                name: x.gmdname,
                                templateId: x.gmdtemplateid,
                                leaders: JSON.parse(x.gmdleaders.replaceAll("`", "\"")),
                                members: JSON.parse(x.gmdmembers.replaceAll("`", "\""))
                            }
                        })

                        var isLeader = false
                        var isMember = false
                        loadeddepartmentslist = loadeddepartmentslist.find(dep => {
                            isLeader = dep.leaders.includes(getSession().userID + "")
                            isMember = dep.members.includes(getSession().userID + "")

                            if (isLeader || isMember) {
                                setDepartmentId(dep.id)
                                isLeader ? setUserlevelDepartment("leader") : setUserlevelDepartment("member")
                            }
                            return isLeader || isMember
                        })


                    }

                }).catch(err => {
            })
        }


        setInterval(() => {
            if (sessionValid()) {
                fetch(APIURL().ping, {
                    credentials: 'include'
                }).catch(async (err) => {
                    logout()
                    history.push("/login")
                })
            } else {
                logout()
                history.push("/login")
            }
        }, 10000);


        window.addEventListener("focus", onFocus)
        return () => {
            window.removeEventListener("focus", onFocus)
        }

    }, [])

    const receiveAlert = () => alert('hello from JS');
    useEffect(() => {

        if (localloggedIn) {
            console.log("loggeding " + localloggedIn)

            if (isflutter) {
                window.function = receiveAlert
                getPushToken()

            } else {
                // getWebpush().then(x => {
                //     if (localStorage.getItem("notiuuid"))
                //         setNotiEnabled(true)
                // })
            }
        }
    }, [localloggedIn])

    useEffect(() => {
        console.log("notification changed:" + notiEnabled)
    }, [notiEnabled])

    const onFocus = () => {
        // if (sessionValid()) {
        //     axios.get(APIURL().ping, { withCredentials: true })
        // } else {
        //     logout()
        //     history.push("/login")
        // }

    }
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    function handleDrawerToggle() {
        setMobileOpen(!mobileOpen)
    }

    const Root = styled('div')(({theme}) => ({
        [`& .${classes.root}`]: {
            display: 'flex',

        },

        [`& .${classes.drawer}`]: {

            [theme.breakpoints.up('sm')]: {
                width: drawerWidth, flexShrink: 0,
            },
        },

        [`& .${classes.appBar}`]: {
            zIndex: theme.zIndex.drawer + 1,
        },

        [`& .${classes.menuButton}`]: {
            marginRight: theme.spacing(2), [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },

        [`& .${classes.toolbar}`]: theme.mixins.toolbar,

        [`& .${classes.drawerPaper}`]: {
            width: drawerWidth
        },

        [`& .${classes.content}`]: {
            flexGrow: 1,
        },

        [`& .${classes.closeMenuButton}`]: {
            marginRight: 'auto', marginLeft: 0,
        }
    }));
    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
        setAccount(true)
    };
    const handleClose = () => {
        setAnchorEl(null);
        setAccount(false)
    };
    const handleNotiDialogClose = () => {
        setNotiDialogOpen(false)
    }
    const activetRoute = route => {
        return route === path;
    }
    const handleOnMouseEnter = (e) => {
        handleDrawerOpen()
    }
    const handleOnMouseLeave = (e) => {
        handleDrawerClose()
    }
    const handleLogout = (e) => {

        const isflutter = typeof window.flutter_inappwebview !== 'undefined'
        if (isflutter) {
            logoutApp()
        } else {

            logout()
        }

        history.push("/login")
        setAccount(false)
    }
    const handleCloseAllDrawers = (e) => {
        setMobileOpen(false)
        setOpen(false)

    }
    const getMenuForUser = () => {

        var usermenu = new Set()

        var mapping = {}
        mapping["erpcloud"] = []
        mapping["education"] = ["etl", "linkmanager", "data"]
        mapping["aicloud"] = ["rxa", "streamer"]
        mapping["sysadmin"] = ["etl", "linkmanager", "data", "reports", "controlcenter", "jobs", "files", "cxa", "thor", "rxa", "streamer"]
        mapping["admin"] = [""]
        mapping["2"] = ["etl", "editor", "documents", "users", "masterdata", "user", "meldung"]
        mapping["3"] = ["meldung"]

        userLevel.forEach(x => {
            console.log(x)
            mapping[x].forEach(y => usermenu.add(y))
            // usermenu.add(...mapping[x])
        })


        return [...usermenu]
    }
    const isValidMenu = (path) => {

        if (usermenu) return usermenu.includes(path)
        else return false
    }

    const handleOpenStoerung = (event) => {
        event.preventDefault()
        setAnchorElsto(event.currentTarget);

    };

    const handleClosenStoerung = () => {
        setAnchorElsto(null);
    };


    const handleExternalLink = (url) => {
        window.flutter_inappwebview.callHandler('openexternalurl', [url])

    };


    const drawer = (<Root
        sx={{
            display: 'flex',
            flexDirection: 'column',

            height: '100%', // Optional: reinforces full height
        }}

        onClick={handleCloseAllDrawers}>

        {isValidMenu("editor") ? <Link to="/editor" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/editor")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/editor") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faNewspaper} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="Vorlageeditor" style={{color: activetRoute("/editor") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}

        {isValidMenu("documents") ? <Link to="/documents" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/documents")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/documents") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faFileInvoice} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="PDF Designer" style={{color: activetRoute("/documents") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}


        {isValidMenu("user") ? <Link to="/user" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/user")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/user") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faBuilding} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="Firmenverwaltung" style={{color: activetRoute("/user") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}
        {isValidMenu("etl") ? <Link to="/etl" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/etl")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/etl") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faFileImport} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="CSV-Importer" style={{color: activetRoute("/etl") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}

        {isValidMenu("masterdata") ? <Link to="/masterdata" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/masterdata")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/masterdata") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faCity} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="Stammdatenverwaltung"
                              style={{color: activetRoute("/masterdata") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}

        {isValidMenu("users") ? <Link to="/users" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/users")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/users") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faUsers} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="Benutzermanagement" style={{color: activetRoute("/users") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}


        {isValidMenu("meldung") ? <Link to="/meldung" style={{color: 'inherit', textDecoration: 'inherit'}}>
            <ListItem button selected={activetRoute("/meldung")}>
                <ListItemIcon>
                    <FontAwesomeIcon
                        inverse={activetRoute("/meldung") ? true : false}
                        // className={activetRoute("/files") ? classes.iconActive : classes.iconDrawer}
                        icon={faTable} size="lg"/>
                </ListItemIcon>
                <ListItemText primary="Ereignismeldung" style={{color: activetRoute("/meldung") ? "white" : "black"}}/>
            </ListItem>
        </Link> : <></>}

        {/* <Divider style={{ marginTop: 5, marginBottom: 5, strokeWidth: 2 }} /> */}
        <ListItem
            sx={{
                mt: 'auto', // Push to bottom using flex (requires parent flex column with height)
                p: 0, // Optional: Remove padding if needed for tightness
            }}
        >
            <Box
                sx={{
                    width: '100%', // Full width
                    padding: 2,
                    display: 'flex',
                    justifyContent: 'flex-start', // Right-align the sub-list (changed from flex-end to match your comment "Left align" but code had flex-end—adjust if needed)
                    alignItems: 'flex-end',
                    backgroundColor: 'inherit',
                }}
            >
                <List
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0,
                        padding: 0,
                        margin: 0,
                        alignItems: 'flex-start', // Left-align items
                    }}
                >
                    <ListItem
                        button
                        onClick={handleOpenStoerung}
                        sx={{
                            color: 'grey.500',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                            width: 'auto',
                            py: 0,
                        }}
                    >
                        <ListItemIcon sx={{minWidth: 'auto', mr: 1, color: 'inherit'}}>
                            <Warning fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText style={{marginLeft: 15}} primary="Störung"/>
                    </ListItem>

                    <Dialog
                        open={Boolean(anchorElsto)}
                        onClose={handleClosenStoerung}
                        aria-labelledby="impressum-dialog-title"
                        aria-describedby="impressum-dialog-description"
                    >
                        <DialogTitle
                            id="impressum-dialog-title">{userlevelDepartment == "leader" ? "Bei Problemen oder Störungen:" : "Bei Probleme oder Störungen"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="impressum-dialog-description">
                                {userlevelDepartment === "leader" ? `
               Unsere Service-Hotline ist Montag bis Freitag von 9 Uhr bis 12 Uhr telefonisch oder per E-Mail erreichbar.
               Die Beantwortung erfolgt in der Regel wochentags innerhalb von 48 Stunden. 
               Tel.: 04131 – 604 33 48
               ` : "Bitte benachrichtigen Sie zeitnah bitte Ihre Leitung, die Geschäftsführung oder die IT-Abteilung."}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClosenStoerung} color="primary">
                                Schliessen
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <ListItem
                        button
                        {...(isflutter
                            ? {onClick: () => handleExternalLink('https://nextsteptechnology.de/privacy-policy/')}
                            : {
                                component: 'a',
                                href: 'https://nextsteptechnology.de/privacy-policy/',
                                target: '_blank',
                                rel: 'noopener noreferrer',
                            })}

                        sx={{
                            color: 'grey.500',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                            width: 'auto',
                            py: 0,
                        }}
                    >
                        <ListItemIcon sx={{minWidth: 'auto', mr: 1, color: 'inherit'}}>
                            <SecurityIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText style={{marginLeft: 15}} primary="Datenschutz"/>
                    </ListItem>

                    <ListItem
                        button
                        {...(isflutter
                            ? {onClick: () => handleExternalLink('https://nextsteptechnology.de/kontakt/')}
                            : {
                                component: 'a',
                                href: 'https://nextsteptechnology.de/kontakt/',
                                target: '_blank',
                                rel: 'noopener noreferrer',
                            })}

                        sx={{
                            color: 'grey.500',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                            width: 'auto',
                            py: 0,
                        }}
                    >
                        <ListItemIcon sx={{minWidth: 'auto', mr: 1, color: 'inherit'}}>
                            <InfoIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText style={{marginLeft: 15}} primary="Impressum"/>
                    </ListItem>

                    {/* <ListItem
        button
        component="a"
        href="https://nextsteptechnology.de/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleCloseAllDrawers}
        sx={{
          color: 'grey.500',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          width: 'auto',
          py: 0,
        }}
      >
        <ListItemIcon sx={{ minWidth: 'auto', mr: 1, color: 'inherit' }}>
          <Shield fontSize="small" />
        </ListItemIcon>
        <ListItemText style={{ marginLeft: 15 }} primary="HinSchG" />
      </ListItem> */}
                </List>
            </Box>
        </ListItem>

    </Root>);

    const UserMenu = () => {


        const popupState = usePopupState({variant: 'popover', popupId: 'demoMenu'})
        return (<div>
            <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                sx={{color: theme.palette.light.main}}
                size="large"
                {...bindTrigger(popupState)}
            >
                <AccountCircle fontSize="medium" className="svg_icons"/>

            </IconButton>

            <Menu {...bindMenu(popupState)}>
                <div style={{
                    display: 'flex', flexDirection: "column", alignContent: "center", alignItems: "center"
                }}>
                    <h3>Informationen:</h3>
                    <MenuItem> Benutzer: {getSession().username}</MenuItem>
                    <MenuItem> Firma: {getSession().dataset}</MenuItem>
                    <MenuItem>
                        <GSButton onClick={handleLogout} icon={<ExitToAppIcon/>} text="Logout"/>
                    </MenuItem>
                </div>
            </Menu>
        </div>)
    }

    const ToolBarContent = () => {
        return <>
            <Link to={"/start"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                <Button>
                    <Hidden xsUp implementation="css">
                        <Typography sx={{color: "light.main"}} variant="h5">
                            Ereignismelder
                        </Typography>
                    </Hidden>
                    <Hidden smDown implementation="css">
                        <Typography sx={{color: "light.main"}} variant="h5">
                            Ereignismelder
                        </Typography>
                    </Hidden>
                </Button>
            </Link>
            <Typography variant="h6" style={{flexGrow: 1}}>
            </Typography>

            {getSession()?.levels.includes("education") ?
                <Link to={"/learn"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                    <Button style={{marginRight: 5}} variant="contained" startIcon={<LocalLibrary/>}>LEARN</Button>
                </Link> : <></>}

            {userlevelDepartment == "leader" && <ActivityLogPopover departmentId={departmentId}/>}


            <IconButton
                style={{marginRight: 10}}
                color="inherit"
                aria-label="Open documentation"
                onClick={e => setDocsOpen(!docsOpen)}
                size="large"
            >
                <HelpOutline/>
            </IconButton>

            <div>{localbroadcast ? <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (<React.Fragment>


                    <Button variant="contained"
                            style={{marginLeft: 10, marginRight: 5}} {...bindTrigger(popupState)}>
                        <VideoCameraBack/>
                    </Button>


                    <Menu {...bindMenu(popupState)}>
                        <MenuItem>
                            <ListItemIcon>
                                <Crop32Icon fontSize="small"/>
                            </ListItemIcon>
                            {getPeerconnections()?.target}
                        </MenuItem>
                        <MenuItem>
                            <ListItemIcon>
                                <VideoCameraFrontIcon fontSize="small"/>
                            </ListItemIcon>
                            {getPeerconnections()?.camera}</MenuItem>
                        <MenuItem>
                            <ListItemIcon>
                                <MicIcon fontSize="small"/>
                            </ListItemIcon>
                            {getPeerconnections()?.audio}</MenuItem>
                        <Button variant="contained" style={{width: "95%", marginLeft: 5}} color="primary"
                                onClick={e => {
                                    var stream = getPeerconnections()

                                    stream.socket.disconnect()
                                    if (window.stream) {
                                        window.stream.getTracks().forEach(track => {
                                            track.stop();
                                        });
                                    }
                                    setPeerConnection(null)
                                    setLocalBroadcast(false)
                                    popupState.close()

                                }}>
                            <ListItemIcon>
                                <StopCircleIcon fontSize="small"/>
                            </ListItemIcon>
                            Übertragung Beenden</Button>
                    </Menu>
                </React.Fragment>)}
            </PopupState> : <div/>} </div>
            <div>
                {getSession() ? <UserMenu/> : <div>
                    <Link to={"/login"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                        <GSButton icon={<LockOpenIcon/>}
                                  text="Bitte einloggen"/>
                    </Link>
                </div>}
            </div>
        </>
    }

    const handleDocsOpen = () => {
        setDocsOpen(true);
    };

    const handleDocsClose = () => {
        setDocsOpen(false);
    };


    return (
        <div>
            <CssBaseline/>
            {isflutter ? <MuiAppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            className={classes.menuButton}
                            size="large">
                            <MenuIcon/>
                        </IconButton>
                        <ToolBarContent/>
                    </Toolbar>
                </MuiAppBar>
                : <>  <Hidden smUp implementation="css">
                    <MuiAppBar position="fixed" className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                className={classes.menuButton}
                                size="large">
                                <MenuIcon/>
                            </IconButton>
                            <ToolBarContent/>
                        </Toolbar>
                    </MuiAppBar>
                </Hidden>

                    <Hidden smDown implementation="css">
                        <AppBar position="fixed" open={open} className={classes.appBar}>
                            <Toolbar>

                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    sx={{
                                        marginRight: '36px', ...(open && {display: 'none'}),
                                    }}>
                                    <MenuIcon/>
                                </IconButton>

                                <ToolBarContent/>

                            </Toolbar>
                        </AppBar>
                    </Hidden></>}


            <nav className={classes.drawer}>

                {isflutter ?
                    <MuiDrawer
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}>
                        <IconButton
                            onClick={handleDrawerToggle}
                            className={classes.closeMenuButton}
                            size="large">
                            <CloseIcon/>
                        </IconButton>
                        {drawer}
                    </MuiDrawer>
                    : <>
                        <Hidden smUp implementation="css">
                            <MuiDrawer
                                variant="temporary"
                                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}>
                                <IconButton
                                    onClick={handleDrawerToggle}
                                    className={classes.closeMenuButton}
                                    size="large">
                                    <CloseIcon/>
                                </IconButton>
                                {drawer}
                            </MuiDrawer>
                        </Hidden>
                        <Hidden smDown implementation="css">
                            <Drawer variant="permanent" open={open}>
                                <DrawerHeader>
                                    <IconButton onClick={handleDrawerClose}>
                                        {theme.direction === 'rtl' ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                                    </IconButton>
                                </DrawerHeader>
                                {drawer}
                            </Drawer>
                        </Hidden></>
                }

            </nav>


            <div style={{display: 'flex', marginTop: 50}}>
                <main style={{flexGrow: 1, maxWidth: "85vw", overflow: 'auto'}}>
                    <div
                        style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {content}
                    </div>
                </main>

                {docsOpen && (
                    <PdfViewerPanel
                        userlevelDepartment={userlevelDepartment}
                        file={userlevelDepartment == "leader" ? "docul.pdf" : "docum.pdf"}
                        onClose={() => setDocsOpen(false)}
                    />
                )}
            </div>

        </div>
    );
}

ResponsiveDrawer.propTypes = {
    // Injected by the documentation to work in an iframe.
    // You won't need it on your project.
    container: PropTypes.object,
};
export default ResponsiveDrawer;